const EVENT_TYPE = {
    ECG: '1',
    PPG: '2',
    RESPIRATION: '3',
    SYSTOLIC: '4',
    DIASTOLIC: '5',
    SPO2: '6',
    TEMPRATURE: '7',
    AF_ECG: '8',
    AF_PPG: '9',
    NO_MEASUREMENT: '11',
    ECG_LOW_QUALITY: '13',
    ECG_LEAD_ON: '15',
    OPEN_SENSOR: '17',
    BRADYCARDIA: '19',
    TACHYCARDIA: '21',
    PAUSE: '23',
    ON_CRADLE: '25',
    POWER_ON: '27',
    WEIGHT: '29',
    GLUCOSE: '30',
    RESPIRATION_MANUAL: '51',
    SYSTOLIC_MANUAL: '52',
    DIASTOLIC_MANUAL: '53',
    SPO2_MANUAL: '54',
    TEMPRATURE_MANUAL: '55',
    GLUCOSE_MANUAL: '56',
    WEIGHT_MANUAL: '57',
  };
  const MIN_MAX = {
    [EVENT_TYPE.PPG]: { MIN: 30, MAX: 240 },
    [EVENT_TYPE.RESPIRATION]: { MIN: 5, MAX: 40 },
    [EVENT_TYPE.SYSTOLIC]: { MIN: 0, MAX: 300 },
    [EVENT_TYPE.DIASTOLIC]: { MIN: 0, MAX: 120 },
    [EVENT_TYPE.SPO2]: { MIN: 70, MAX: 100 },
    [EVENT_TYPE.TEMPRATURE]: { MIN: 30, MAX: 50 },
    [EVENT_TYPE.WEIGHT]: { MIN: 0, MAX: 300 },
    [EVENT_TYPE.GLUCOSE]: { MIN: 20, MAX: 420 },
  };
  const PERCENTILES = {
    GENERAL_LOW: 0.05,
    GENERAL_HIGH: 0.95,
    HISTOGRAM_LOW: 0.02,
    HISTOGRAM_HIGH: 0.95,
  };

  module.exports = { 
    EVENT_TYPE, 
    MIN_MAX, 
    PERCENTILES, 
  };